import { render, staticRenderFns } from "./BuilderForms_old.vue?vue&type=template&id=1ccf7956&scoped=true"
import script from "./BuilderForms_old.vue?vue&type=script&lang=js"
export * from "./BuilderForms_old.vue?vue&type=script&lang=js"
import style0 from "./BuilderForms_old.vue?vue&type=style&index=0&id=1ccf7956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf7956",
  null
  
)

export default component.exports